/* MT-Mega (02.10.2026): Verhalten des neuen Hauptmenüs. Markup: snippets/mt-mega.liquid, Aussehen: assets/mt-mega.css.
   Desktop (ab 1001 px): Klappen öffnen nach 150 ms Verweilen, schließen 300 ms nach dem Verlassen; wechselt man
   zwischen Oberpunkten, öffnet die nächste Klappe sofort. Klick auf einen Bereich, dessen Klappe schon offen ist, folgt dem
   Link des Bereichs (07.10.2026, Weg a); der erste Klick auf einen geschlossenen Bereich öffnet nur. Touch: erstes Tippen öffnet, zweites folgt dem Link.
   Tastatur: Pfeil runter/Leertaste öffnet, Esc schließt. Bolt-Action-Nationen zeigen beim Überfahren eine Vorschau.
   Handy (bis 1000 px, Mathieu 02.10. abends: „einfach, nicht verdrahtet“): zwei Ebenen. Ebene 1 = Liste der Bereiche,
   Ebene 2 = alles eines Bereichs auf einer Seite, Gruppen als zweispaltige Knöpfe (Nationen mit Fahne).
   Gebaut beim ersten Öffnen des Xtra-Menüs (html.m2a) aus demselben Markup. Nur <a>-Elemente: Xtra stylt #nav button. */
(function () {
  if (window.__mtMega) return;
  window.__mtMega = true;
  var html = document.documentElement;
  var root = document.querySelector('[data-mtg]');
  if (!root) return;
  html.classList.add('mtg-an');
  var nav = document.getElementById('nav');
  var mqD = window.matchMedia('(min-width:1001px)');
  var EN = (html.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN
    ? { alles: 'Everything in', mini: 'Miniatures', inf: 'Infantry', pz: 'Tanks', st: 'Starter armies', allesFuer: 'Everything for', artikel: 'products', zur: 'Back' }
    : { alles: 'Alles in', mini: 'Miniaturen', inf: 'Infanterie', pz: 'Panzer', st: 'Starterarmeen', allesFuer: 'Alles für', artikel: 'Artikel', zur: 'Zurück' };
  try { localStorage.removeItem('mt-weiter'); } catch (e) {} // Merker der verworfenen „Weiter bei“-Zeile
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function zahl(n) { n = parseInt(n, 10); return isNaN(n) ? '' : n.toLocaleString(EN ? 'en-GB' : 'de-DE'); }
  function alle(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  // 07.10.2026: Icon aus dem Satz (liegt als <template data-mtg-ic> in mt-mega.liquid), statt mit CSS gezeichneter Winkel und Kreuze
  function ic(name, cls) { var w = el('span', cls); w.setAttribute('aria-hidden', 'true'); var t = root.querySelector('template[data-mtg-ic="' + name + '"]'); var s = t && t.content && t.content.firstElementChild; if (s) w.appendChild(s.cloneNode(true)); return w; }

  /* ---------- Desktop ---------- */
  var items = alle('[data-mtg-i]', root);
  var offen = null, tAuf = 0, tZu = 0, touch = false;
  // 07.10.2026 (Weg a): Bereich, über dessen Namen man gerade auf seine Übersichtsseite gekommen ist. Solange der Zeiger noch
  // darauf steht, öffnet das Überfahren die Klappe nicht (sie läge sonst sofort wieder über der neuen Seite).
  var ruhig = null;
  var versteckt = [];
  function zu() {
    if (!offen) return;
    versteckt.forEach(function (x) { x.style.visibility = ''; }); versteckt = [];
    offen.querySelector('[data-mtg-k]').hidden = true;
    offen.querySelector('.mtg-p').setAttribute('aria-expanded', 'false');
    offen = null;
  }
  function auf(it) {
    if (offen === it) return;
    zu();
    offen = it;
    var k = it.querySelector('[data-mtg-k]');
    k.hidden = false;
    it.querySelector('.mtg-p').setAttribute('aria-expanded', 'true');
    if (!k.__mtgBilder) {
      k.__mtgBilder = true;
      alle('img.mtg-fl', k).forEach(function (i) { var f = el('i', 'mtg-flfeld'); /* i statt span: das erste span im Link ist der Name (CSS und Handy-Skript verlassen sich darauf) */ i.parentNode.insertBefore(f, i); f.appendChild(i); var los = function () { zuschneiden(i, 28, 20, 1, 1); if (f.classList.contains('mt-emblem')) zuschneiden(i, 1, 1, 0.9, 0.9); }; /* Emblem: Feld wird per CSS quadratisch und größer */ if (i.complete && i.naturalWidth) los(); else i.addEventListener('load', los); i.loading = 'eager'; });
      alle('img.mtg-lgbild', k).forEach(function (i) { var los = function () { zuschneiden(i, 16, 9, 0.9, 0.84); }; if (i.complete && i.naturalWidth) los(); else i.addEventListener('load', los); i.loading = 'eager'; });
    }
    // Niedrige Bildschirme (Laptop 1366 x 650): Klappe endet im Fenster und scrollt innen, „Alle …“ bleibt unten stehen
    var unten = window.innerHeight, klein = [];
    [[40, 40], [window.innerWidth / 2, 12], [window.innerWidth - 40, 40]].forEach(function (p) {
      (document.elementsFromPoint(p[0], window.innerHeight - p[1]) || []).forEach(function (x) {
        if (!x || root.contains(x) || (nav && nav.contains(x)) || x.contains(root)) return;
        var fest = x; while (fest && fest !== document.body && getComputedStyle(fest).position !== 'fixed') fest = fest.parentElement;
        if (!fest || fest === document.body || fest.contains(root)) return;
        var fr = fest.getBoundingClientRect();
        if (fr.width >= window.innerWidth * 0.5) { if (fr.top > window.innerHeight / 2 && fr.top < unten) unten = fr.top; }
        else if (klein.indexOf(fest) < 0) klein.push(fest);
      });
    });
    k.style.maxHeight = Math.max(240, unten - k.getBoundingClientRect().top - 10) + 'px';
    k.scrollTop = 0;
    // M1 (Geräte-Test): steht die Klappe nur wenig über (bis 60 px), dichter setzen statt innen scrollen
    k.classList.remove('mtg-k--dicht');
    var ueber = k.scrollHeight - k.clientHeight;
    if (ueber > 1 && ueber <= 110) k.classList.add('mtg-k--dicht');
    k.style.overscrollBehavior = k.scrollHeight > k.clientHeight + 1 ? 'contain' : 'auto';
    var kb = k.getBoundingClientRect().bottom;
    klein.forEach(function (x) { if (x.getBoundingClientRect().top < kb && versteckt.indexOf(x) < 0) { x.style.visibility = 'hidden'; versteckt.push(x); } });
  }
  document.addEventListener('pointerdown', function (e) { touch = e.pointerType === 'touch' || e.pointerType === 'pen'; }, true);
  items.forEach(function (it) {
    var p = it.querySelector('.mtg-p');
    var k = it.querySelector('[data-mtg-k]');
    it.addEventListener('mouseenter', function () { if (!mqD.matches || touch || ruhig === it) return; clearTimeout(tZu); clearTimeout(tAuf); tAuf = setTimeout(function () { auf(it); }, offen ? 0 : 150); });
    it.addEventListener('mouseleave', function () { if (!mqD.matches || touch) return; if (ruhig === it) ruhig = null; clearTimeout(tAuf); tZu = setTimeout(zu, 300); });
    // 05.10.2026: Klick auf den Bereichsnamen lädt keine Seite mehr, er öffnet nur die Klappe (vorher lud erst die Übersichtsseite,
    // dann klappte das Menü darüber auf - das verwirrte). Zur Übersichtsseite führt der Link oben in der Klappe.
    // 07.10.2026 (GPT A19-001, Weg a): Ist die Klappe dieses Bereichs schon offen, folgt ein einzelner Maus- oder Fingerklick dem
    // Link (vorher tat er nichts, auch der zweite nicht). e.detail: 0 = Tastatur (bleibt: öffnet nur), 2 = zweiter Klick eines Doppelklicks.
    p.addEventListener('click', function (e) {
      if (!mqD.matches || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (offen === it && e.detail === 1) { try { sessionStorage.setItem('mtg-folgt', p.getAttribute('data-mtg-key') || ''); } catch (err) {} return; }
      e.preventDefault(); clearTimeout(tAuf); clearTimeout(tZu); ruhig = null; auf(it);
    });
    p.addEventListener('keydown', function (e) {
      if (!mqD.matches) return;
      if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); auf(it); var f = k.querySelector('a'); if (f) f.focus(); }
    });
  });
  alle('.mtg-haus,.mtg-alle,[data-mtg-rechts],[data-mtg-sale]', root).forEach(function (a) {
    a.addEventListener('mouseenter', function () { if (!mqD.matches) return; clearTimeout(tAuf); tAuf = setTimeout(zu, 150); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !offen) return;
    var p = offen.querySelector('.mtg-p'); zu(); p.focus();
  });
  document.addEventListener('click', function (e) { if (offen && !root.contains(e.target)) zu(); });
  document.addEventListener('focusin', function (e) { if (offen && !offen.contains(e.target)) zu(); });
  mqD.addEventListener && mqD.addEventListener('change', zu);
  // 07.10.2026 (Weg a): nach dem Klick auf einen Bereichsnamen merkt sich die Zielseite den Bereich (ruhig), bis der Zeiger ihn verlässt.
  // Steht der Zeiger bei der ersten Bewegung gar nicht mehr darauf, entfällt der Merker sofort.
  try {
    var folgt = sessionStorage.getItem('mtg-folgt');
    if (folgt !== null) {
      sessionStorage.removeItem('mtg-folgt');
      items.forEach(function (it) { if (it.querySelector('.mtg-p').getAttribute('data-mtg-key') === folgt) ruhig = it; });
      if (ruhig) document.addEventListener('mousemove', function erste(e) { document.removeEventListener('mousemove', erste, true); if (ruhig && !ruhig.contains(e.target)) ruhig = null; }, true);
    }
  } catch (e) {}
  // „Zurück“ im Browser: eine beim Wegklicken offene Klappe ist auf der wiederhergestellten Seite zu
  window.addEventListener('pageshow', function (e) { if (e.persisted) { clearTimeout(tAuf); clearTimeout(tZu); zu(); } });
  // Klick, der vor dem Laden dieses Skripts kam (Sofort-Abfänger in mt-mega.liquid): Klappe jetzt öffnen
  if (window.__mtgWartet && mqD.matches) { auf(window.__mtgWartet.parentNode); window.__mtgWartet = null; }

  /* Nationen-Vorschau (Spalten mit Flaggen in einer Klappe, die ein Schaufenster hat) */
  items.forEach(function (it) {
    var k = it.querySelector('[data-mtg-k]');
    var schau = k.querySelector('[data-mtg-schau]');
    if (!schau) return;
    var original = null;
    alle('.mtg-sp--fl a[data-mtg-h]', k).forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        if (original === null) original = Array.prototype.slice.call(schau.childNodes);
        var img = a.querySelector('img');
        var name = a.querySelector('span').textContent;
        var u = a.getAttribute('href');
        var box = el('div', 'mtg-nv');
        if (img) { var gross = el('img'); gross.src = img.currentSrc.replace(/width=\d+/, 'width=480') || img.src; gross.alt = ''; gross.width = 240; gross.height = 160; box.appendChild(gross); }
        box.appendChild(el('b', '', name));
        box.appendChild(el('span', 'mtg-n', zahl(a.dataset.mtgN) + ' ' + T.artikel));
        var liste = el('div', 'mtg-sl');
        [[T.inf, 'Infanterie'], [T.pz, 'Panzer'], [T.st, 'Starterarmee']].forEach(function (x) {
          var l = el('a'); l.href = u + (u.indexOf('?') < 0 ? '?' : '&') + 'mtf_pt=' + encodeURIComponent(x[1]); l.appendChild(el('span', '', x[0])); liste.appendChild(l);
        });
        var ganz = el('a'); ganz.href = u; var s = el('span'); s.appendChild(el('b', '', T.allesFuer + ' ' + name)); ganz.appendChild(s); liste.appendChild(ganz);
        box.appendChild(liste);
        schau.replaceChildren(box);
      });
    });
    k.querySelector('.mtg-raster').addEventListener('mouseleave', function () { if (original) { schau.replaceChildren.apply(schau, original); original = null; } });
  });

  /* ---------- Handy ---------- */
  var mtm = null;
  function zeile(liste, href, text, n, cls) {
    var li = el('li'), a = el('a', cls || ''); a.href = href;
    a.appendChild(el('span', 'mtm-tx', text));
    if (n) a.appendChild(el('span', 'mtm-n', zahl(n)));
    li.appendChild(a); liste.appendChild(li); return a;
  }
  // Knopf im Raster. art: logo/bild = Bild groß oben + Name darunter, fl = Fahne links + Name, text = nur Name
  function knopf(raster, href, text, src, art, breit) {
    var a = el('a', 'mtm-k--' + art + (breit ? ' mtm-k--breit' : '')); a.href = href;
    if (src) {
      var i = el('img', 'mtm-b mtm-b--' + art); i.alt = ''; i.decoding = 'async';
      if (art === 'logo' || art === 'bild') {
        // Bildfeld 16:9; das Bild wird nach dem Laden auf seinen sichtbaren Teil zugeschnitten (zuschneiden)
        var feld = el('span', 'mtm-feld'); feld.appendChild(i); a.appendChild(feld);
        i.addEventListener('load', function () { zuschneiden(i); });
      } else {
        var ff = el('span', 'mtm-flfeld'); ff.appendChild(i); a.appendChild(ff);
        i.addEventListener('load', function () { zuschneiden(i, 36, 26, 1, 1); if (ff.classList.contains('mt-emblem')) zuschneiden(i, 1, 1, 0.9, 0.9); });
      }
      i.src = src;
    }
    a.appendChild(el('span', '', text));
    raster.appendChild(a);
  }
  // 03.10.2026 (Handy-Test): Die Logos sind verschieden gebaut (quadratisch mit viel Rand, randlos, breit). Ein fester
  // Zuschnitt schnitt „ACTION“ ab und ließ andere winzig. Deshalb: sichtbaren Teil messen (transparenter oder weißer Rand
  // zählt nicht) und das Bild so legen, dass genau dieser Teil das 16:9-Feld füllt. Nichts wird abgeschnitten.
  // Schlägt das Messen fehl (fremde Domain), bleibt die sichere Darstellung „ganz sichtbar“ aus dem CSS.
  function zuschneiden(img, FW, FH, fb, fh) {
    FW = FW || 16; FH = FH || 9; fb = fb || 0.94; fh = fh || 0.88;
    try {
      var n = 64, c = document.createElement('canvas'); c.width = n; c.height = n;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data;
      var eckeDurchsichtig = d[3] < 24 || d[(n - 1) * 4 + 3] < 24 || d[(n * (n - 1)) * 4 + 3] < 24;
      var x0 = n, y0 = n, x1 = -1, y1 = -1;
      for (var py = 0; py < n; py++) for (var px = 0; px < n; px++) {
        var k = (py * n + px) * 4, sichtbar = d[k + 3] > 24;
        if (sichtbar && !eckeDurchsichtig) sichtbar = !(d[k] > 238 && d[k + 1] > 238 && d[k + 2] > 238);
        if (sichtbar) { if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py; }
      }
      if (x1 < 0) return;
      var bw = (x1 - x0 + 1) / n, bh = (y1 - y0 + 1) / n, cx = (x0 + x1 + 1) / 2 / n, cy = (y0 + y1 + 1) / 2 / n;
      var r = (img.naturalWidth || 1) / (img.naturalHeight || 1);
      // Feld = 16 x 9 Einheiten, Inhalt füllt höchstens 88 % der Breite und 80 % der Höhe
      var h = Math.min(FW * fb / (bw * r), FH * fh / bh), w = h * r; // Feld = FW x FH Einheiten
      // !important, weil Xtra Bilder im Menü auf 100 % Breite zwingt
      img.style.setProperty('width', (w / FW * 100) + '%', 'important'); img.style.setProperty('height', (h / FH * 100) + '%', 'important');
      img.style.left = ((FW / 2 - cx * w) / FW * 100) + '%'; img.style.top = ((FH / 2 - cy * h) / FH * 100) + '%';
      img.classList.add('mtm-b--fertig');
      // quadratisches Emblem (Konflikt-'47-Fraktionen, Balkenkreuz) statt Fahne: ohne Fahnenrahmen
      if (img.parentNode && bw * r / bh < 1.25) img.parentNode.classList.add('mt-emblem');
    } catch (e) {}
  }
  function bildVon(a) { var i = a.querySelector('img'); return i ? (i.currentSrc || i.src) : ''; }
  function zeige(ebene, richtung) {
    mtm.replaceChildren(ebene);
    if (richtung) ebene.classList.add(richtung);
    if (nav) nav.scrollTop = 0;
  }
  // Ebene 1: Bereiche mit Pfeil, darunter Service-Zeilen
  function ebene1(richtung) {
    var e = el('div', 'mtm-e');
    var l = el('ul', 'mtm-l');
    items.forEach(function (it) {
      var p = it.querySelector('.mtg-p');
      var a = zeile(l, p.href, p.textContent.trim(), p.dataset.mtgN, 'mtm-s');
      a.setAttribute('role', 'button');
      a.appendChild(ic('chevron-right', 'mtm-pfeil'));
      a.addEventListener('click', function (ev) { ev.preventDefault(); ebene2(it); });
    });
    e.appendChild(l);
    e.appendChild(el('div', 'mtm-t'));
    var l2 = el('ul', 'mtm-l');
    alle('[data-mtg-rechts]', root).forEach(function (a) { zeile(l2, a.href, a.textContent.trim(), a.dataset.mtgN); });
    var akt = document.querySelector('#nav-top .mt-aktion'); if (akt) zeile(l2, akt.href, akt.textContent.trim(), '', 'mtm-rot');
    else { var sale = root.querySelector('[data-mtg-sale]'); if (sale) zeile(l2, sale.href, 'Sale', '', 'mtm-rot'); }
    var ap = root.querySelector('[data-mtg-alle]'); if (ap) zeile(l2, ap.href, ap.textContent.trim());
    var st = root.querySelector('[data-mtg-start]'); if (st) zeile(l2, st.href, st.textContent.trim());
    var hilfe = document.querySelector('#nav-top .mt-hilfe'); if (hilfe) zeile(l2, hilfe.href, hilfe.textContent.trim());
    e.appendChild(l2);
    zeige(e, richtung);
  }
  // Ebene 2: ganzer Bereich auf einer Seite - „Alle …“, dann je Gruppe Überschrift + Knöpfe
  function ebene2(it) {
    var p = it.querySelector('.mtg-p'), k = it.querySelector('[data-mtg-k]');
    var e = el('div', 'mtm-e');
    var z = el('a', 'mtm-zur', p.textContent.trim()); z.insertBefore(ic('chevron-left', 'mtm-zurpf'), z.firstChild); z.href = '#'; z.setAttribute('role', 'button'); z.setAttribute('aria-label', T.zur);
    // Zurück-Geste des Handys: Ebene 2 bekommt einen Verlaufseintrag, „Zurück“ führt dann zur Bereichsliste statt aus dem Shop
    z.addEventListener('click', function (ev) { ev.preventDefault(); if (inEbene2) history.back(); else ebene1('zurueck'); });
    // Zurück-Zeile mit Schließen-Kreuz bleibt oben stehen: der Xtra-Kopf („Menü“, Kreuz) scrollt mit dem Inhalt weg
    var zz = el('div', 'mtm-zurzeile'); zz.appendChild(z);
    var zu2 = el('a', 'mtm-x'); zu2.href = '#'; zu2.setAttribute('role', 'button'); zu2.setAttribute('aria-label', EN ? 'Close menu' : 'Menü schließen'); zu2.appendChild(ic('close', 'mtm-xic'));
    zu2.addEventListener('click', function (ev) { ev.preventDefault(); var c = nav && nav.querySelector('.close-nav'); if (c) c.click(); });
    zz.appendChild(zu2);
    if (nav) zz.style.top = (-parseFloat(getComputedStyle(nav).paddingTop) || 0) + 'px';
    e.appendChild(zz);
    if (nav && !nav.__mtmScroll) { nav.__mtmScroll = true; nav.addEventListener('scroll', function () { var z2 = nav.querySelector('.mtm-zurzeile'); if (z2) z2.classList.toggle('mtm-fest', nav.scrollTop > 40); }, { passive: true }); }
    if (!inEbene2) { try { history.pushState({ mtm: 2 }, ''); inEbene2 = true; } catch (err) {} }
    // Baukasten-Einträge überall als Bild-Knopf: Bilder aus der Spalte „Bundle-Baukasten“ nach Zieladresse
    var bkBild = {};
    alle('[data-mtg-bk] [data-mtg-l]', root).forEach(function (a) { var s = bildVon(a); if (s) bkBild[a.pathname] = s.replace(/width=\d+/, 'width=400'); });
    var oben = el('div', 'mtm-alle');
    var fuss = alle('[data-mtg-alle-k]', k);
    if (fuss.length) fuss.forEach(function (a) {
      var x = el('a'); x.href = a.href; x.appendChild(el('span', '', a.querySelector('span').textContent.trim())); if (a.dataset.mtgN) x.appendChild(el('span', 'mtm-n', zahl(a.dataset.mtgN))); oben.appendChild(x);
    });
    else {
      // ohne eigene „Alle …“-Zeile: zeigt die Klappe unten denselben Link wie der Bereich (Hersteller -> „Alle Marken A–Z“), dessen Text nehmen
      var still = k.querySelector('.mtg-still'), x = el('a'); x.href = p.href;
      x.appendChild(el('span', '', still && still.pathname === p.pathname ? still.textContent.trim() : T.alles + ' ' + p.textContent.trim())); oben.appendChild(x);
    }
    e.appendChild(oben);
    // Roter Faden (Mathieu 02.10. spät): Spielsysteme + Marken = Logo-Knopf (Logo groß oben, Name darunter),
    // Bundle-Baukasten = Bild-Knopf (gleicher Aufbau), Nationen = Fahnen-Knopf, alles andere = Text-Knopf.
    // In jeder Gruppe erst die Bild-Knöpfe, dann die Text-Knöpfe in eigenem Raster, damit nichts durcheinander steht.
    function gross(src) { return src ? src.replace(/width=\d+/, 'width=400') : ''; }
    function gruppeBauen(titel, eintraege) {
      // Gruppe besteht nur aus Baukasten-Zielen (z. B. „Farbset zusammenstellen“) -> dieselben Bild-Knöpfe wie unter Bundles & Sets
      if (eintraege.length && eintraege.every(function (x) { return x.art === 'text' && bkBild[x.pfad]; })) eintraege.forEach(function (x) { x.art = 'bild'; x.src = bkBild[x.pfad]; });
      var bilder = eintraege.filter(function (x) { return x.art === 'logo' || x.art === 'bild'; });
      var rest = eintraege.filter(function (x) { return x.art !== 'logo' && x.art !== 'bild'; });
      // ungerade Zahl an Bild-Knöpfen: den ersten Text-Knopf daneben setzen, damit keine halbe Zeile leer bleibt
      if (bilder.length % 2 === 1) bilder[bilder.length - 1].breit = true;
      e.appendChild(el('div', 'mtm-h', titel));
      [bilder, rest].forEach(function (liste) {
        if (!liste.length) return;
        var r = el('div', 'mtm-kn'); e.appendChild(r);
        liste.forEach(function (x) { knopf(r, x.href, x.text, x.src, x.art, x.breit); });
      });
    }
    // Zeitleiste: je Epoche die Systeme als Logo-Knöpfe, dann die Maßstäbe als Text-Knöpfe
    alle('[data-mtg-zr]', k).forEach(function (r) {
      gruppeBauen(r.querySelector('[data-mtg-kopf]').textContent.trim(), alle('[data-mtg-l]', r).map(function (a) {
        var t = a.querySelector('span').textContent.trim();
        if (a.hasAttribute('data-mtg-ms')) return { href: a.href, text: T.mini + ' ' + t, art: 'text' };
        // 08.10.2026 (GPT A19): Restbestand (data-mtg-rest, derzeit Flames of War) bekommt keine Logo-Kachel, sondern einen
        // schlichten Textknopf am Ende der Gruppe: auffindbar, aber nicht beworben.
        if (a.hasAttribute('data-mtg-rest')) return { href: a.href, text: t, art: 'text', rest: true };
        var src = gross(bildVon(a));
        return { href: a.href, text: t, src: src, art: src ? 'logo' : 'text' };
      }).sort(function (x, y) { return (x.rest ? 1 : 0) - (y.rest ? 1 : 0); }));
    });
    // Spalten
    alle('[data-mtg-sp]', k).forEach(function (sp) {
      var istBk = sp.hasAttribute('data-mtg-bk'), istFl = sp.classList.contains('mtg-sp--fl'), marke = '';
      gruppeBauen(sp.querySelector('[data-mtg-kopf]').textContent.trim(), alle('[data-mtg-l]', sp).map(function (a) {
        if (istBk) return { href: a.href, text: a.querySelector('.mtg-bt > span').textContent.trim(), src: gross(bildVon(a)), art: 'bild' };
        var t = a.querySelector('span').textContent.trim();
        if (istFl) return { href: a.href, text: t, src: bildVon(a), art: 'fl' };
        if (a.dataset.mtgLogo) { marke = t; return { href: a.href, text: t, src: a.dataset.mtgLogo, art: 'logo' }; }
        if (a.hasAttribute('data-mtg-einr') && marke) t = marke + ' ' + t; // „Model Color“ -> „Vallejo Model Color“
        return { href: a.href, text: t, art: 'text', pfad: a.pathname };
      }));
    });
    zeige(e, 'vor');
  }
  function oeffnen() {
    if (mqD.matches) return;
    if (!mtm) { mtm = el('div', 'mtm'); mtm.setAttribute('role', 'navigation'); root.parentNode.insertBefore(mtm, root); }
    ebene1();
  }
  // Verlauf: Zurück (Geste, Taste oder Zurück-Zeile) aus Ebene 2 zeigt wieder die Bereichsliste
  var inEbene2 = false;
  window.addEventListener('popstate', function () {
    if (!inEbene2) return;
    inEbene2 = false;
    if (mtm && html.classList.contains('m2a')) ebene1('zurueck');
  });
  var warOffen = html.classList.contains('m2a');
  new MutationObserver(function () {
    var jetzt = html.classList.contains('m2a');
    if (jetzt && !warOffen) oeffnen();
    // Menü in Ebene 2 geschlossen: den eigenen Verlaufseintrag wieder abbauen
    if (!jetzt && warOffen && inEbene2) { try { history.back(); } catch (e) {} }
    warOffen = jetzt;
  }).observe(html, { attributes: true, attributeFilter: ['class'] });
  if (warOffen) oeffnen();
})();
